var _clipPath, _clipPath2, _clipPath3, _clipPath4, _path, _g, _path2, _circle, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle2, _circle3, _g3, _path18, _path19, _circle4, _g4, _circle5, _circle6, _circle7, _circle8, _circle9, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipP1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 677,
    height: 913,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 676.7 912.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.2 576.5l145.8 50v102l-188.8-8z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.4 576.5l-145.7 50v102l188.8-8z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.2 750.8c47.4-47.4 137-196.2 23.7-353S337.7 17.2 337.7 17.2 329.8 241 216.5 397.8s-23.7 305.6 23.7 353z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 333.8,
    cy: 548.2,
    r: 52.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M491.2 576.5l145.8 50v102l-188.8-8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e21e38",
    d: "M587.8 759.1v-97.4l-180-51V761z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M405.8 763V608l184 52v101zm4-149.6v145.5l176-1.7v-94z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M627.3 784.6V372s1.8 140.5 33.4 231.8c31.2 90.2 15 166-33.4 181z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 627.3,
    cy: 371.9,
    r: 15.4,
    fill: "#e21e38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M185.4 576.5l-145.7 50v102l188.8-8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e21e38",
    d: "M88.9 759.1v-97.4l180-51V761z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M270.9 763l-184-1.9v-101l1.4-.4 182.5-51.6zm-180-5.8l176 1.7V613.4l-176 49.8z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M458.9 397.8C345.6 241.1 337.7 17.2 337.7 17.2S329.8 241 216.5 397.8s-23.7 305.6 23.7 353h195c47.4-47.4 137-196.2 23.7-353z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M452 775c15.4 9 23.6 28.4 24.3 38.3s0 37-27.1 49.2-37.2 31.6-37.2 31.6H263.4s-10.1-19.4-37.2-31.6-27.7-39.3-27-49.2S208 784 223.3 775z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M412 896H262.2l-.6-1a57.9 57.9 0 0 0-8.2-10.9 88 88 0 0 0-28-19.8c-27.6-12.6-29-40-28.3-51.1a56.6 56.6 0 0 1 25.3-40l.4-.3h229.7l.5.3a56.6 56.6 0 0 1 25.2 40c.7 11.2-.6 38.5-28.2 51a88 88 0 0 0-28 20 57.3 57.3 0 0 0-8.2 10.8l-.6 1zm-147.5-4h146.3a84 84 0 0 1 37.5-31.4c25.4-11.5 26.6-36.8 26-47.2a53 53 0 0 0-22.9-36.4H224a53 53 0 0 0-22.8 36.4c-.7 10.4.6 35.7 25.9 47.2 24 11 34.9 27.1 37.4 31.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e21e38",
    d: "M342.7 766.2S356 777 356 813.9s-13.3 53.4-13.3 88h-8c0-34.6-16-51.2-16-88s16-47.7 16-47.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M344.7 903.9h-12v-2c0-16.7-3.8-29-7.8-42-4-13.3-8.3-27-8.3-46 0-37.5 16.3-49 17-49.4l2.2 3.3c-.1.1-15.2 11-15.2 46 0 18.5 4.2 32 8.2 45a140 140 0 0 1 8 41h4c.2-16.2 3.4-28.8 6.5-41 3.3-13 6.7-26.5 6.7-45 0-35.5-12.4-46-12.5-46l2.5-3.2c.6.5 14 11.9 14 49.3 0 19-3.5 32.7-6.9 46-3.2 13-6.4 25.2-6.4 42z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e21e38",
    d: "M312.8 764.4s-17.7 13.8-17.1 50c.5 30.8 19.7 37.8 22.3 85.2l-12.5 1s0-13.8-30.5-62.4c-19.2-30.5-10.5-65 12.3-73.8s25.5 0 25.5 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M303.4 902.6v-2.1s0-3.6-3.9-13a326.4 326.4 0 0 0-26.2-48.3 63.4 63.4 0 0 1-8.2-52.7 37.1 37.1 0 0 1 21.5-24c11-4.2 19.2-5.1 24.2-2.6a7 7 0 0 1 3.8 4l.4 1.3-1 .8c-.3.2-16.9 13.8-16.3 48.4a74.5 74.5 0 0 0 8.9 32.7c5.6 12.3 12 26.3 13.4 52.4l.1 2zm.6-140.1c-3.4 0-8.5.9-16 3.8a33.2 33.2 0 0 0-19.1 21.4 59.6 59.6 0 0 0 7.8 49.4c24.4 39 29.5 55.8 30.5 61.3l8.7-.6a124 124 0 0 0-13-49 79 79 0 0 1-9.3-34.3c-.5-31 12-46 16.5-50.3-.9-.8-2.7-1.7-6.1-1.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e21e38",
    d: "M270.6 759.1s-28.2 18-22 58c4 25 30.7 44.8 44.8 84.8l-15 1.3s-2.6-12.3-26.2-38.2c-17.6-19.3-32.5-22.4-34.3-47.4-1.2-16.8 5.3-50.6 52.7-58.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M277 905.3l-.4-1.7c0-.1-3.1-12.2-26-37.3a158.8 158.8 0 0 0-14.3-13.7c-10.7-9.2-19-16.5-20.4-35-.6-8.5-.7-51.3 54.4-60.5l9.7-1.6-8.3 5.3c-1.1.7-27 17.9-21 56 1.8 12 9.4 23 18.1 35.8 9.1 13.2 19.4 28.3 26.5 48.6l.9 2.4zm-14-142.4c-15.8 4.4-45.7 17.6-43 54.5 1.1 16.8 8.2 23 19 32.2a163.3 163.3 0 0 1 14.7 14c19 21 24.7 33.2 26.3 37.4l10.7-.9c-7-18.6-16.6-32.7-25.1-45.2-9-13.2-16.9-24.6-18.9-37.5a62.7 62.7 0 0 1 9-45.4 59.3 59.3 0 0 1 7.4-9.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e21e38",
    d: "M362.2 764.4s17.7 13.8 17.1 50c-.5 30.8-19.7 37.8-22.3 85.2l12.5 1s0-13.8 30.5-62.4c19.2-30.5 10.5-65-12.3-73.8s-25.5 0-25.5 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M371.5 902.6l-2.1-.1-14.5-1v-2c1.5-26.1 8-40.1 13.5-52.5 4.7-10.2 8.7-19 9-32.6.5-34.9-16.2-48.3-16.4-48.4l-1-.9.3-1.3a7 7 0 0 1 3.9-4c5-2.4 13.2-1.5 24.2 2.7a37.2 37.2 0 0 1 21.5 24c5.4 16.2 2.4 36-8.2 52.7a327.4 327.4 0 0 0-26.2 48.4 45 45 0 0 0-4 12.9zm-12.4-4.8l8.7.6c1-5.5 6-22.4 30.5-61.3a59.4 59.4 0 0 0 7.8-49.4 33.3 33.3 0 0 0-19.1-21.4c-13-5-18.8-4-21-2.9a5.5 5.5 0 0 0-1 .7c4.3 4.3 17 19.2 16.4 50.4-.3 14.5-4.6 24-9.2 34.2-5.5 11.7-11.5 25-13.1 49z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e21e38",
    d: "M404.4 759.1s28.3 18 22 58c-4 25-30.8 44.8-44.8 84.8l14.9 1.3s2.7-12.2 26.3-38.2c17.6-19.3 32.5-22.4 34.3-47.4 1.1-16.8-5.3-50.6-52.7-58.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M398 905.3l-1.7-.2-17.5-1.4.8-2.5c7.2-20.3 17.5-35.3 26.5-48.6 8.8-12.8 16.3-23.8 18.2-35.8a56 56 0 0 0-21-56l-8.3-5.2 9.7 1.6c55.1 9.2 55 52 54.3 60.5-1.3 18.4-9.7 25.7-20.3 35a158.8 158.8 0 0 0-14.4 13.6c-22.8 25.1-25.9 37.2-25.9 37.3zm-13.7-5.2l10.7 1c1.6-4.3 7.2-16.5 26.3-37.5a163.3 163.3 0 0 1 14.8-14c10.7-9.3 17.8-15.4 19-32.2.5-7.5.7-43.6-43.5-54.7 8.3 8.2 21.2 26 16.7 54.7-2 13-9.8 24.3-18.8 37.5-8.6 12.5-18.2 26.6-25.2 45.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M258.6 891.6h158.2v20.5H258.6zM49.3 784.6V372S47.6 512.4 16 603.7c-31.2 90.2-15 166 33.3 181z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.7,
    cy: 17.2,
    r: 17.2,
    fill: "#e21e38"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.3,
    cy: 371.9,
    r: 15.4,
    fill: "#e21e38"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M364.6 185.8c17.5 77.2 7 179.1-51 238.8s-138.8 81.7-134.3 227.9-50 135.6-50 135.6l113.2-78.7s-40-106.1 30.7-188.2c71-82.4 137-142.6 110.7-271.5l-13.2-64V141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e01d39",
    d: "M131.6 790.3a15.1 15.1 0 0 1-2.7-.2l-4.7-1 37.1-25.7c9.8-18.4 17.8-51.5 16-110.9-1.5-51.2 7.4-92 27.2-124.4C222.3 499 247 479 271 459.5c14-11.2 28.3-23 41.3-36.3 58.4-60.1 67.4-162.3 50.4-237v-.3l6.1-45.2 4 .3v44.6l13.2 63.7c11 54.4 6.8 100-13.5 143.5-18.3 39-47.9 72.8-79.2 108.6l-18.4 21.1c-36.1 42-42.5 90.3-41.4 123.5 1 36 10.9 62.4 11 62.7l.5 1.4-80.6 56a55.9 55.9 0 0 1-12.4 16 31.3 31.3 0 0 1-20.3 8.2zm24.1-18.2L136 785.8a29.8 29.8 0 0 0 13.3-6.9 45 45 0 0 0 6.4-6.8zm210.9-586.4c17 75.7 7.8 179.2-51.5 240.3a462.5 462.5 0 0 1-41.7 36.6c-24.7 20.1-48 39-65.5 67.5-19.4 31.9-28.2 71.9-26.6 122.3 1.6 53.6-4.8 86.4-13.4 106.4l72.2-50.2a226.6 226.6 0 0 1-10.7-62.5c-1-33.9 5.4-83.3 42.3-126.2l18.4-21.2c31.2-35.5 60.6-69 78.6-107.6 20-42.7 24.2-87.5 13.2-141L368.7 186v-15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M420.6 336.6c12 61.5-6.3 127.4-71.3 190.7-46 44.8-73.7 114.7-43 177.6s136.9 103.9 79 0c-35.7-64-20.2-107 26.4-168.2s48.2-114.4 34.6-157.2-42.1-128.2-25.7-42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e01d39",
    d: "M386.7 770.4H385c-11.6-.6-27.6-8-42.8-19.7a131.7 131.7 0 0 1-37.8-44.9 133.9 133.9 0 0 1-7.4-97 192.2 192.2 0 0 1 50.8-82.9c31-30 52.5-62.1 64-95.2a178 178 0 0 0 6.8-93.7c-2.4-12.4-4-21.8-4.6-28-.9-7.7-.5-10.2 1.8-10.8s4 1.6 7.3 9c2 4.7 4.7 11.6 7.9 20.4 6.4 17.9 13.5 39.8 17.1 51.3a152.3 152.3 0 0 1 5.3 72.6c-5 28.7-18.5 57.8-40.3 86.4-45.4 59.8-61.9 101.9-26.1 166.1 16 28.9 21 48.9 14.4 59.3-2.9 4.6-8 7-14.8 7zm36-434.2a182 182 0 0 1-7 95.7c-11.8 33.7-33.6 66.3-65 96.8a188 188 0 0 0-49.8 81.2 130 130 0 0 0 7.2 94.2c16.4 33.6 55 61.1 77.2 62.2 6.2.3 10.5-1.4 12.8-5.2 7.4-12-6-39.7-14.6-55.2-17.6-31.6-23.3-59.1-17.8-86.6 4.8-24.1 18-49.2 44.4-83.8a196.8 196.8 0 0 0 39.4-84.6 148.1 148.1 0 0 0-5.1-70.8c-14.3-45-22.8-67.5-26.7-75.2.2 4.2 1.4 13 5 31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M487.5 404.4c29.8 90.5-1.8 137.2-29 180.9-41.7 67.2-6.1 120.7 8.4 150.2 12 24.6 93.5-121.2 93.5-121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e01d39",
    d: "M471.1 740.3h-.4a6.3 6.3 0 0 1-5.6-3.9l-4.5-8.8c-15.8-30.4-42.3-81.4-3.8-143.4l2.4-3.7c13.3-21.4 27-43.4 33.9-71 7.8-31.4 5.3-65.5-7.5-104.4l3.8-1.3 73.2 210.7-.5.8c-.2.3-17.6 31.5-37.3 62.3-38.8 60.6-49.8 62.7-53.7 62.7zm28.3-295.6c9.5 63.5-14.9 102.7-36.8 137.9l-2.4 3.7a114.8 114.8 0 0 0-18 80.7 189 189 0 0 0 22 58.8l4.4 8.9c.7 1.4 1.5 1.6 2.2 1.6 10.5 0 38.8-42.5 50.6-60.9 17.9-28 34-56.3 36.8-61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M337.7 73.8c0 84.8 33 167.3-30.2 269.1S153 437.9 88.9 576.5c0 0 13.1-115 117.6-199.3S333 263.9 336.5 64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e01d39",
    d: "M85.5 588.6l1.4-12.3c0-.3 3.5-29.5 19.8-68.6 15-36 44.3-88.3 98.6-132 49.2-39.8 83-69 102.2-112.5 17.8-40 25.1-93.8 27-198.6l4-.3 1.2 9.5c0 21.3 2.2 43 4.2 64 6.4 63.7 12.9 129.5-34.7 206.2-28 45-60.6 68.4-95.2 93.2-43 30.8-87.5 62.7-123.3 140.1zm251.7-480c-3 77.3-10.7 121.7-26 156.2-19.7 44.2-53.7 73.8-103.4 114A332.7 332.7 0 0 0 110.4 509a313.2 313.2 0 0 0-17 53.4c35-69 77.3-99.2 118.2-128.5 34.3-24.6 66.7-47.8 94.2-92.1 46.8-75.5 40.4-140.7 34.1-203.7-.9-9.7-1.9-19.6-2.7-29.5z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M472.9 709.4l-15 65.5H217.5l-15-65.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2574",
    d: "M316.2 62.9h43v21.9h-43z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.8,
    cy: 548.2,
    r: 94.1,
    fill: "#1d2574"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.8 650.3a102 102 0 1 1 102-102.1 102.2 102.2 0 0 1-102 102zm0-188.2a86 86 0 1 0 86 86 86.2 86.2 0 0 0-86-86z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.8,
    cy: 548.2,
    r: 52.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.8,
    cy: 479,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.8,
    cy: 617.3,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.6,
    cy: 548.2,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.9,
    cy: 548.2,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.9,
    cy: 499.3,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.7,
    cy: 597.1,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.9,
    cy: 597.1,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.7,
    cy: 499.3,
    r: 4.8
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.8,
    cy: 742.2,
    r: 5.5,
    fill: "#1d2574"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.2,
    cy: 742.2,
    r: 5.5,
    fill: "#1d2574"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.5,
    cy: 742.2,
    r: 5.5,
    fill: "#1d2574"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.8,
    cy: 742.2,
    r: 5.5,
    fill: "#1d2574"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 387.5,
    cy: 742.2,
    r: 5.5,
    fill: "#1d2574"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#d0d3ea",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.8 648.5l195-195 26.2 26.3-195 195zM208.6 625.3l195-195 11.3 11.5-195 195z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipP1);
export default __webpack_public_path__ + "static/media/ship-p1.c5397e4d8f3e5765dd811c37c38581d8.svg";
export { ForwardRef as ReactComponent };